<template>
    <div class='pb-4 row'>
        <search-dialog
            :self-message='$t("translations.search_cant_select_provider_xref")'
            :exists-message='$t("translations.search_item_already_exists_provider_xref")'
            :existing='$parent.item.provider_provider_xref'
            existing-id-field='relation_id'
            :self='$parent.item'
            v-on:selected='addProviderXref'
            ref='searchDialog'
            :source="this.$root.apiBase + '/providers?search='"
            title='Provider Search'></search-dialog>

        <div class="col-20">
            <h2 class='section-heading' id="userDetails">{{ $t('translations.provider_details')}}</h2>
            <input type='hidden' v-model='$parent.item.id'>

            <!-- <div class="form-group d-flex">
                <label for='name' class="col-10 col-form-label">Organisation Name<span class="required">*</span></label>
                <input type='text' v-model='$parent.item.organisation_name' class='form-control col-14'>
            </div> -->

            <div class="form-group d-flex">
                <label for='name' class="col-10 col-form-label">{{ $t('translations.provider_name')}}<span class="required">*</span></label>
                <input type='text' v-model='$parent.item.name' class='form-control col-14'>
            </div>

            <div class="form-group d-flex">
                <label for='practice_code' class="col-10 col-form-label">{{ $t('translations.practice_code')}}<span class="required">*</span></label>
                <input type='text' v-model='$parent.item.practice_code' class='form-control col-14'>
            </div>
            <template v-if='$parent.type == "create"'>
                <div class="form-group d-flex">
                    <label for='site_name' class="col-10 col-form-label">{{ $t('translations.site_name')}}<span class="required">*</span></label>
                    <input type='text' v-model='$parent.item.site_name' class='form-control col-14'>
                </div>
                <hr>
                <div class="form-group d-flex">
                    <label for='superuser_gender' class="col-10 col-form-label">{{ $t('translations.superuser_gender')}}<span class="required">*</span></label>
                    <select v-model='$parent.item.superuser_gender' class='w-100 form-control'>
                        <option v-for="(value, key) in $root.lookup.genders" :value="key" :key="key">{{$t(value)}}</option>
                    </select>
                </div>

                <div class="form-group d-flex">
                    <label for='superuser_forenames' class="col-10 col-form-label">{{ $t('translations.superuser_forenames')}}<span class="required">*</span></label>
                    <input type='text' v-model='$parent.item.superuser_forenames' class='form-control col-14'>
                </div>

                <div class="form-group d-flex">
                    <label for='superuser_surname' class="col-10 col-form-label">{{ $t('translations.superuser_surname')}}<span class="required">*</span></label>
                    <input type='text' v-model='$parent.item.superuser_surname' class='form-control col-14'>
                </div>

                <div class="form-group d-flex">
                    <label for='superuser_email' class="col-10 col-form-label">{{ $t('translations.superuser_email')}}<span class="required">*</span></label>
                    <input type='text' v-model='$parent.item.superuser_email' class='form-control col-14'>
                </div>
                <hr>
                <div class="form-group d-flex">
                    <p class='col-24'>{{ $t('translations.robot_name')}}</p>
                </div>
                <div class="form-group d-flex">
                    <label for='robot_forenames' class="col-10 col-form-label">{{ $t('translations.robot_forenames')}}<span class="required">*</span></label>
                    <div class='w-100'>
                        <input type='text' v-model='$parent.item.robot_forenames' class='form-control'>
                        <!-- <p>Leave blank to auto-populate with first part of the provider name.</p> -->
                    </div>
                </div>

                <div class="form-group d-flex">
                    <label for='robot_surname' class="col-10 col-form-label">{{ $t('translations.robot_surname')}}<span class="required">*</span></label>
                    <div class='w-100'>
                        <input type='text' v-model='$parent.item.robot_surname' class='form-control'>
                        <!-- <p>Leave blank to auto-populate with the last part of the provider name.</p> -->
                    </div>
                </div>

                <div class="form-group d-flex">
                    <label for='robot_email' class="col-10 col-form-label">{{ $t('translations.robot_email')}}</label>
                    <div class='w-100'>
                        <input type='text' v-model='$parent.item.robot_email' class='form-control'>
                        <p>{{ $t('translations.leave_blank_to_auto_populate_with')}}: amg-noreply-[PROVIDER_ID]@askmygp.uk</p>
                    </div>
                </div>

            </template>
            <hr>
            <div class="form-group d-flex">
                <label class="col-10 col-form-label">
                    {{ $t('translations.demo_mode')}}
                </label>

                <div class='w-100'>
                    <label></label>
                    <!-- <b-form-checkbox v-model="$parent.item.demo_mode" name="check-button" switch></b-form-checkbox> -->
                    <toggle-button sync v-model='$parent.item.demo_mode' :labels="{checked: this.$t('translations.on'), unchecked: this.$t('translations.off')}"/>
                    <p v-if='$parent.type == "create"'>{{ autobrand('translations.demo_create_50_reqests_message')}}</p>
                </div>
            </div>
            <hr>
            <div class="form-group">
                <label class="col-10 col-form-label">
                    {{ $t('translations.service_availability')}}
                </label>
                <toggle-button sync v-model="$parent.item.service_status" :labels="{checked: this.$t('translations.on'), unchecked: this.$t('translations.off')}"/>
            </div>
            <hr>
            <div class="form-group">
                <label class="col-10 col-form-label">
                    {{ $t('translations.video_available')}}
                </label>
                <toggle-button sync v-model='$parent.item.video_available' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
            </div>

            <div v-if='$parent.item.video_available' class="form-group">
                <label class="col-10 col-form-label">
                    {{ $t('translations.video_enabled')}}
                </label>
                <toggle-button sync v-model='$parent.item.video_enabled' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
            </div>

            <div v-if='is_network_admin()' class="form-group">
                <label class="col-10 col-form-label">
                    {{ $t('translations.appointment_booking_enabled')}}
                </label>
                <toggle-button sync v-model='$parent.item.appointment_booking_enabled' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
            </div>

            <div v-if='is_network_admin()' class="form-group">
                <label class="col-10 col-form-label">
                    {{ $t('translations.clinician_gender_selection_enabled')}}
                </label>
                <toggle-button sync v-model='$parent.item.clinician_gender_selection_enabled' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
            </div>

            <div v-if='is_network_admin()' class="form-group">
                <label class="col-10 col-form-label">
                    {{ $t('translations.campaigns_enabled')}}
                </label>
                <toggle-button sync v-model='$parent.item.campaigns_enabled' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
            </div>

            <div v-if='is_network_admin()' class="form-group">
                <label class="col-10 col-form-label">
                    {{ $t('translations.reports_enabled')}}
                </label>
                <toggle-button sync v-model='$parent.item.reports_enabled' :labels="{checked: this.$t('translations.yes'), unchecked: this.$t('translations.no')}"/>
            </div>

            <div class="form-group d-flex">
                <label for='wait_exit_time' class="col-10 col-form-label">{{ autobrand('translations.time_requests_return_waiting')}}</label>
                <div class='w-100'>
                    <input type='time' placeholder='HH:MM' v-model='$parent.item.wait_exit_time' class='form-control'>
                </div>
            </div>

            <div class="form-group d-flex">
                <label for='wait_default_days' class="col-10 col-form-label">{{ $t('translations.set_waiting_days')}}</label>
                <div class='w-100'>
                    <input type='number' min='1' max='28' v-model='$parent.item.wait_default_days' class='form-control'>
                </div>
            </div>

            <div class="form-group d-flex">
                <label for='practice_list_size' class="col-10 col-form-label">{{ capitalise($t('translations.list_size')) }}</label>
                <div class='w-100'>
                    <input type='number' min='0' v-model='$parent.item.practice_list_size' class='form-control'>
                </div>
            </div>

            <div class="form-group d-flex">
                <label for='practice_type_id' class="col-10 col-form-label">{{ $t('translations.practice_type')}}</label>
                <select v-model='$parent.item.practice_type_id' class='w-100 form-control'>
                        <option v-for="(value, key) in $root.lookup.practice_types" :value="key" :key="key">{{value}}</option>
                </select>
            </div>

            <div class="form-group d-flex">
                <label for='practice_operational_status_id' class="col-10 col-form-label">{{ $t('translations.practice_status')}}</label>
                <select v-model='$parent.item.practice_operational_status_id' class='w-100 form-control'>
                        <option v-for="(value, key) in $root.lookup.practice_operational_statuses" :value="key" :key="key">{{value}}</option>
                </select>
            </div>

            <div class="form-group d-flex">
                <label for='provider_type_id' class="col-10 col-form-label">{{ $t('translations.provider_type')}}</label>
                <select v-model='$parent.item.provider_type_id' class='w-100 form-control'>
                        <option v-for="(value, key) in $root.lookup.provider_types" :value="key" :key="key">{{value}}</option>
                </select>
            </div>

            <div v-if='is_network_admin()' class="form-group d-flex">
                <label for='sms_smtp_gateway_domain' class="col-10 col-form-label">{{ capitalise($t('translations.sms_smtp_gateway_domain')) }}</label>
                <div class='w-100'>
                    <input type='text' v-model='$parent.item.sms_smtp_gateway_domain' class='form-control'>
                </div>
            </div>

            <div v-if='is_network_admin()' class="form-group d-flex">
                <label for='record_system_integration_type' class="col-10 col-form-label">{{ $t('translations.record_system_integration_type')}}</label>
                <select v-model='$parent.item.record_system_integration_type_id' class='w-100 form-control'>
                        <option :value="null">None</option>
                        <option v-for="(value, key) in $root.lookup.record_system_integration_types" :value="key" :key="key">{{value}}</option>
                </select>
            </div>

            <template v-if='$parent.item.record_system_integration_type_id == 1'>
                <inline-error type='writeback_user_id'></inline-error>
                <div class="form-group d-flex">
                    <label class="col-10 col-form-label" for='name'>{{ autobrand('translations.default_writeback_user') | capitalise}}:</label>
                    <div class='w-100' v-if='is_superuser() || is_admin() || is_network_admin()'>
                        <select class='form-control' v-model='$parent.item.writeback_user_id'>
                            <option :value="null">-- {{ $t('translations.none')}} --</option>
                            <template v-for='(user) in staff'>
                                <option v-if='user.provider.mrs_user_id' :key='user.id' :value='user.id'>
                                    {{ formatNameCompliant(user) }}
                                </option>
                            </template>
                        </select>
                    </div>
                    <span v-else class="inputViewOnly">{{ formatNameCompliant(staff.find(obj => {return obj.user_id == $parent.item.writeback_user_id})) &nbsp; }}</span>
                </div>
            </template>

            <div v-if='is_network_admin()' class="form-group d-flex">
                <label class="col-10 col-form-label">
                    {{ capitalise($t('translations.provider_url')) }}
                </label>
                <div class='w-100'>
                    <input type='text' v-model='$parent.item.provider_url' class='form-control'>
                    <small v-html="autobrand('translations.provider_url_help', {'default_provider_url': getDefaultProviderUrl() })">
                    </small>
                </div>
            </div>
            


            <!-- <div class="form-group d-flex">
                <label for='record_system_test_user_id' class="col-10 col-form-label">{{ capitalise($t('translations.record_system_test_user_id')) }}</label>
                <div class='w-100'>
                    <input type='number' min='0' v-model='$parent.item.record_system_test_user_id' class='form-control'>
                </div>
            </div> -->
            <hr>

            <h2 class='section-heading' id="userDetails">{{ $t('translations.network')}}</h2>

            <form class="d-flex flex-row">
                <div class="flex-fill">
                    <template v-for='(xref, index) in $parent.item.provider_provider_xref'>
                        <div :key='xref.relation_id' class="d-flex align-items-center mb-2">
                            <!-- <input type='radio' name='default_site_id' :value='site.id' v-model='provider.default_site_id'> -->

                            <div class="col-md-16">
                                {{ $parent.item.provider_provider_xref[index].relation.name }}
                                <input type="hidden" v-model="$parent.item.provider_provider_xref[index].relation_id">
                            </div>
                            <div class="col-auto ml-auto mr-3">
                                <button v-on:click.prevent='$parent.item.provider_provider_xref.splice(index, 1)' class="btn btn-round btn-sm btn-danger float-right">{{ $t('translations.remove')}}</button>
                            </div>
                        </div>
                    </template>

                    <div style="background: #ccc;">
                        <button v-on:click.prevent='$refs.searchDialog.show' class="btn btn-primary btn-outline btn-block btn-round btn-sm float-right">{{ $t('translations.add')}}</button>
                    </div>

                </div>
            </form>
			<!-- branding upload removed -->
            <!-- <template v-if='is_network_admin()'>
                <h2 class='section-heading' id="userDetails">{{ $t('translations.branding')}}</h2>

                
                <div class='m-3 alert alert-info text-dark'>
                    <p>{{ $t('translations.custom_brand_info_files') }}</p>
                    <p class="pt-2">{{ $t('translations.custom_brand_info_auto_include') }}</p>
                </div>
                <div class="form-group d-flex">
                    <label for='name' class="col-10 col-form-label">{{ $t('translations.custom_brand_files') }}</label>
                    <input ref='file_upload' type='file' @change="file_update($event.target.files)" multiple>
                </div>
                <template v-if="$parent.item.existing_files && $parent.item.existing_files.length">
                    <h2 class='section-heading' >{{ $t('translations.existing_files') }}</h2>
                    
                    <table class="table">
                        <tr>
                            <th>{{ $t('translations.filename') | capitalise }}</th>
                            <th>{{ $t('translations.url') | capitalise }}</th>
                            <th>{{ $t('translations.delete')  | capitalise }}</th>
                        </tr>
                        <tr v-for="(file, index) in $parent.item.existing_files">
                            <td>{{ file["basename"] }}</td>
                            <td>{{ file["url"] }}</td>
                            <td><input type='checkbox' v-model="$parent.item.delete_files" :value='file["basename"]' :name="`brand_file_${index}`"></td>
                        </tr>    
                    </table>
                </template>
            </template> -->
        </div>
    </div>
</template>

<script>
	export default {
		props: {
            title: {
                default: null
            }
		},
		data: function() {
			return {
                files: null,
                staff: [],
			};
		},
        computed: {

        },
        methods: {
            resetItem() {
                this.$parent.item = {

                    // organisation_name: "",
                    provider_name: "",
                    practice_code: "",
                    superuser_gender: "",
                    superuser_forenames: "",
                    superuser_surname: "",
                    superuser_email: "",
                    robot_forenames: "",
                    robot_surname: "",
                    robot_email: "",
                    site_name: "",
                    service_status: 0,
                    video_available: 1,
                    video_enabled: 1,
                    appointment_booking_enabled: 1,
                    clinician_gender_selection_enabled: 1,
                    campaigns_enabled: 0,
                    reports_enabled: 0,
                    demo_mode: 0,
                    wait_exit_time: "10:00",
                    wait_default_days: 7,
                    practice_list_size: 0,
                    practice_type_id: 2,
                    practice_operational_status_id: 1,
                    provider_type_id: 1,
                    provider_provider_xref: [],
                    provider_url: this.getDefaultProviderUrl(),
                }
                this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));
            },
            addProviderXref(event) {
                console.info(event);
                this.$parent.item.provider_provider_xref.push({relation_id: event.id, relation: {name: event.name}});
            },
            loadItem(id) {
                this.$parent.setLoading(true);
                axios.get(this.$parent.route + '/' + id ).then((res) => {
                    this.$parent.item = res.data[this.$parent.model];
                    axios.get(`${this.$root.apiBase}/staff?p=0&provider_id=${id}`).then((res) => {
                        this.staff = res.data.data;
                        axios.get(`/api/v0/provider/brand_files/${id}`, {}).then((res) => {
                            Vue.set(this.$parent.item, "existing_files", res.data.files);
                            Vue.set(this.$parent.item, "delete_files", []);
                            this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));
                            this.$parent.setLoading(false);
                            
                        }).catch((error) => {
                            this.$parent.setLoading(false);
                            this.handleError(error, "branding");
                        })
                    }).catch((error) => {
                        this.$parent.setLoading(false);
                        this.handleError(error, "branding");
                    })
                }).catch((error) => {
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "load");
                    this.$parent.$router.push({path: "/" + this.$parent.event + "-list"});
                });
            },
            updateItem(event) {
                
                this.setLoading(true);

                var form = new FormData();
                if(this.files) {
                    for(const file of this.files) {
                        form.append("files[]", file);
                    }    
                }
                
                form.append("data", JSON.stringify(this.$parent.item));

                // for(var [index, item] of Object.entries(this.$parent.item)) {
                //     form.append(index, item);
                // }

                axios.post(this.$parent.route + '/' + this.$parent.item.id, form, {headers: {'Content-Type': 'multipart/form-data' }}).then((res) => {
                    //console.log(res.data);
                    this.$parent.setLoading(false);
                    this.$parent.addNotification({type: "success", content: this.$parent.elementname + " " + this.$parent.getName() + " " + this.$t('translations.notification_updated_successfully') + "."});
                    this.$parent.originalData = null;
                    this.$parent.closePanel(true);
                }).catch((error) => {
                    console.log("error: " + JSON.stringify(error, null, 2));
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "update", this.$parent.event + "-list");
                    this.$parent.$refs.editScroller.scrollTop = 0;
                });
            },

            createItem(event) {
                var form = new FormData();
                
                if(this.files) {
                    for(const file of this.files) {
                        form.append("files[]", file);
                    }    
                }

                form.append("data", JSON.stringify(this.$parent.item));

                                
                this.setLoading(true);
                axios.post(this.$parent.route, form, {headers: {'Content-Type': 'multipart/form-data' }}).then((res) => {
                    this.$parent.setLoading(false);

                    this.$parent.addNotification({type: "success", content: this.tBrandKey(this.elementname) + " " + this.$parent.getName() + " " + this.$t('translations.notification_created_successfully') + "."});
                    this.$parent.item.id = res.data.id;
                    this.$parent.originalData = null;
                    this.$parent.closePanel(true);
                }).catch((error) => {
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "create");
                    this.$parent.$refs.editScroller.scrollTop = 0;
                });
            },
            file_update(files) {
                this.files = files;
            },
            getDefaultProviderUrl() {
                return window.location.hostname.replace("admin", window.location.hostname.endsWith("admin.askmygp.uk") ? "nhs" : "provider");
            }
        }
    }
</script>
